import $ from 'jquery';
import * as Utils from 'lib/utils';

const W = window;
const $W = $(window);

const READ_NOTIFICATION = `
  mutation readNotification($id: Int!) {
    read: readNotification(id: $id)
  }
`;

const READ_ALL_NOTIFICATION = `
  mutation readAllNotifications {
    read: readAllNotifications
  }
`;

const GET_UNREAD_NOTIFICATIONS = `
  query getUnreadNotifications {
    notifications: getUnreadNotifications {
      id
      type
      message
      data
      created_at
      unread_count
    }
  }
`;

$.onAuth(({ authenticated, website, user }) => {
  if (authenticated) {
    const $desktopBtn = $('.app-header-item.btn-notification');
    const $mobileBtn = $('.dropdown-item.btn-notification.d-md-none');
    const $profile = $('.btn-profile');
    const $popover = $('#notifications-popover');
    const $unread = $('.app-header .badge-notification');
    let unread = user.unread_notifications;

    const renderUnreadCount = () => {
      $unread.text(unread).toggleClass('d-none', unread <= 0);
    };

    const renderEmptyNotifications = () => {
      $popover.find('.notifications').empty().append('<div class="text-center p-2">You have no unread notifications</div>');
      $popover.find('.row').remove();
    };

    const setUnreadCount = count => {
      unread = count;
      renderUnreadCount();
    };

    const isPopoverLoading = $trigger => $trigger.data('loaded') === true;

    const resetPopoverLoading = $trigger => {
      $trigger.data('loaded', false);
    };

    const setPopoverLoading = $trigger => {
      $trigger.data('loaded', true);
    };

    const showPopoverFrom = $trigger => {
      if (!$trigger.length || !$trigger.is(':visible')) {
        resetPopoverLoading($trigger);
        return;
      }

      $trigger.popover('show');
    };

    $profile.on('show.bs.dropdown', () => {
      if ($profile.data('bs.popover')) $profile.popover('hide');
    });

    const loadNotifications = async () => {
      const { notifications } = await $.GraphQL.runQuery(GET_UNREAD_NOTIFICATIONS, { operationName: 'getUnreadNotifications' });

      setUnreadCount(notifications.length ? notifications[0].unread_count : 0);
      $popover.render('notifications_popover', notifications, Utils);
    };

    renderUnreadCount();

    $desktopBtn
      .on('show.bs.popover', async evt => {
        const $trigger = $(evt.currentTarget);
        if (isPopoverLoading($trigger)) return;

        evt.preventDefault();

        setPopoverLoading($trigger);

        try {
          await loadNotifications();
          showPopoverFrom($trigger);
        } catch (err) {
          resetPopoverLoading($trigger);
          throw err;
        }
      })

      .on('shown.bs.popover', evt => {
        resetPopoverLoading($(evt.currentTarget));
      });

    $mobileBtn.on('click', async evt => {
      evt.preventDefault();
      if (isPopoverLoading($profile)) return;

      setPopoverLoading($profile);

      try {
        await loadNotifications();

        if (!$profile.data('bs.popover')) {
          const data = $desktopBtn.first().data();

          $profile
            .attr('data-popover', '')
            .data('popover', '')
            .data('trigger', 'manual')
            .data('target', data.target)
            .data('color', data.color)
            .data('title', data.title)
            .data('size', data.size)
            .data('class', data.class)
            .data('clone', data.clone)
            .data('boundary', data.boundary)
            .data('container', data.container)
            .data('arrow', data.arrow)
            .data('animation', data.animation)
            .data('placement', data.placement)
            .data('html', data.html);

          $.initPopover($profile);
        }

        $profile.dropdown('hide');
        setTimeout(() => showPopoverFrom($profile), 0);
      } catch (err) {
        resetPopoverLoading($profile);
        throw err;
      }
    });

    $profile.on('shown.bs.popover', () => {
      resetPopoverLoading($profile);
    });

    $popover.on('click', '.btn-read-all', async evt => {
      const { read } = await $.GraphQL.runQuery(READ_ALL_NOTIFICATION, { operationName: 'readAllNotifications' });

      if (read) {
        setUnreadCount(0);
        renderEmptyNotifications();
      }
    });

    $popover.on('click', '.notification', async evt => {
      const $notification = $(evt.target).closest('.notification');
      const $btn = $(evt.target).closest('.btn');
      const notify_id = $notification.data('id');

      if ($notification.data('is_read') !== true) {
        const { read } = await $.GraphQL.runQuery(READ_NOTIFICATION, { variables: { id: notify_id }, operationName: 'readNotification' });

        if (read) {
          unread--;
          renderUnreadCount();
          $notification.data('is_read', true);
        }
      }

      if ($btn.length && $btn.attr('target')) $notification.trigger('click');

      $notification.slideOut({
        duration: 500,
        easing: 'easeOutExpo',
        complete: () => {
          const $notifications = $notification.parent();

          $notification.remove();

          if ($notifications.children('.notification').length === 0) renderEmptyNotifications();
        },
      });
    });

    $.subscribe(
      [
        { type: 'discrete', name: 'notify' },
        { type: 'discrete', name: `notify:${user.id}` },
      ],
      (channel, payload) => {
        const { notify_id, user_id, timeout = 0, type = 'info', message, data } = payload;
        const buttons = [];

        if (type === 'command') {
          switch (message) {
            case 'theme': {
              let $theme = $('style#theme');
              let $meta = $('meta[name=theme-color], meta[name=msapplication-navbutton-color], meta[name=apple-mobile-web-app-status-bar-style]');

              if (!$theme.length) $theme = $('<style></style>').attr('id', 'theme').appendTo('head');
              if (!$meta.length) $meta = $('<meta name="theme-color"/><meta name="msapplication-navbutton-color"/><meta name="apple-mobile-web-app-status-bar-style"/>').appendTo('head');

              $meta.attr('content', data.primary);
              $theme.html(
                `:root { ${Object.entries(Utils.omit(data, 'uri'))
                  .map(([k, v]) => `--${k}: ${v};`)
                  .join(' ')} }
                `,
              );

              break;
            }

            case 'logrocket': {
              $W.trigger('logrocket', data);
              break;
            }

            case 'reload':
              location.reload();
              break;

            case 'logout':
              location.href = Utils.baseUri('/logout');
              break;
          }

          return;
        }

        if (user_id) {
          unread++;
          $unread.text(unread).removeClass('d-none');
        }

        if (data) {
          if (data.auction_id)
            buttons.push(`
              <a href="${Utils.baseUri(`/?auction_id=${data.auction_id}&items=all`)}" class="btn btn-sm">
                <i class="fas fa-table mr-2"></i>
                <span>Go to Auction</span>
              </a>
            `);
          if (data.lot_id)
            buttons.push(`
              <a href="${Utils.baseUri(`/lot/${data.lot_id}`)}" class="btn btn-sm">
                <i class="fas fa-table mr-2"></i>
                <span>Go to Lot</span>
              </a>
            `);

          if (data.product_id)
            buttons.push(`
              <a href="${Utils.baseUri(`/product/${data.product_id}`)}" class="btn btn-sm">
                <i class="fas fa-table mr-2"></i>
                <span>Go to Product</span>
              </a>
            `);

          if (data.listing_id)
            buttons.push(`
              <a href="${Utils.baseUri(`/listing/${data.listing_id}`)}" class="btn btn-sm">
                <i class="fas fa-table mr-2"></i>
                <span>Go to Listing</span>
              </a>
            `);
        }

        $.toastr({
          timeout,
          type,
          message,
          buttons,
          onclick: async evt => {
            const $toast = $(evt.target).closest('.toast');
            const $btn = $(evt.target).closest('.btn');
            const is_read = $toast.data('is_read');

            if (notify_id && is_read !== true) {
              const { read } = await $.GraphQL.runQuery(READ_NOTIFICATION, { variables: { id: notify_id }, operationName: 'readNotification' });

              if (read) {
                unread--;
                $unread.text(unread).toggleClass('d-none', unread <= 0);
                $toast.data('is_read', true);
              }
            }

            if ($btn.length && $btn.attr('target')) $toast.trigger('click');
          },
        });
      },
    );
  }
});
